export default function SettingsPage() {
  return <div data-testid="page-settings">Settings</div>;
}
